import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import {
  BoxesIcon,
  ComponentsIcon,
  RelationsIcon,
  ThirdPartyIcon,
} from '@mercedes-benz/odp-theme-v2';
import ApiIcon from '@mui/icons-material/Api';
import InfoIcon from '@mui/icons-material/Info';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ShieldIcon from '@mui/icons-material/Shield';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { EntityPageLayout } from '../entity-details/EntityPageLayout';
import { CoreDetailsTab } from './CoreDetailsTab';
import { ComponentsTab } from './ComponentsTab';
import { APIsTab } from './APIsTab';
import { InfrastructureTab } from './InfrastructureTab';
import { RelationsTab } from './RelationsTab';
import { ResourcesTab } from './ResourcesTab';
import { SecurityTab } from './SecurityTab';
import { ThirdPartyTab } from './ThirdPartyTab';
import { DiagramTab } from '../entity-details/DiagramTab';

const TABS: TabNavItem[] = [
  { id: 'core-details', label: 'Core Details', icon: InfoIcon },
  { id: 'components', label: 'Components', icon: ComponentsIcon },
  { id: 'apis', label: 'APIs', icon: ApiIcon },
  { id: 'infrastructure', label: 'Infrastructure', icon: ApartmentIcon },
  { id: 'diagram', label: 'Diagram', icon: AccountTreeIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
  { id: 'resources', label: 'Resources', icon: BoxesIcon },
  { id: 'security', label: 'Security', icon: ShieldIcon },
  { id: '3rd-party', label: '3rd Party', icon: ThirdPartyIcon },
];

export const SystemDetailsPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'core-details' && <CoreDetailsTab />}
        {activeTab === 'components' && <ComponentsTab />}
        {activeTab === 'apis' && <APIsTab />}
        {activeTab === 'infrastructure' && <InfrastructureTab />}
        {activeTab === 'diagram' && <DiagramTab />}
        {activeTab === 'relations' && <RelationsTab />}
        {activeTab === 'resources' && <ResourcesTab />}
        {activeTab === 'security' && <SecurityTab />}
        {activeTab === '3rd-party' && <ThirdPartyTab />}
      </>
    )}
  </EntityPageLayout>
);
